import axiosClient from "./axios";
import { SEARCH_PRODUCT_URL } from "../constants/endpoints";

class globalCatalogManagementService {
  static async fetchTableData(
    currentPage: number,
    itemsPerPage: number,
    emptyImagesArray: boolean | null = null,
    barcode: string | null = null,
    maxImagesCount: number | null = null,
    productName: string | null = null,
    isActive: boolean | null = null,
    subCategory: string | null = null,
    brand: string | null = null,
    category: string | null = null,
    dataSource: string | null = null,
    isGeneratedByCat: boolean | null = null
  ) {
    const filters = {
      emptyImagesArray:
        emptyImagesArray !== null ? emptyImagesArray : undefined,
      barcode: barcode !== null ? barcode : undefined,
      maxImagesCount: maxImagesCount !== null ? maxImagesCount : undefined,
      productName: productName !== null ? productName : undefined,
      isActive: isActive !== null ? isActive : undefined,
      subCategory: subCategory !== null ? subCategory : undefined,
      brand: brand !== null ? brand : undefined,
      category: category !== null ? category : undefined,
      dataSource: dataSource !== null ? dataSource : undefined,
      isGeneratedByCat:
        isGeneratedByCat !== null ? isGeneratedByCat : undefined,
    };

    return axiosClient.post(`${SEARCH_PRODUCT_URL}`, {
      page: currentPage,
      limit: itemsPerPage,
      filters: filters,
    });
  }
}

export default globalCatalogManagementService;
